import React from "react";

const IconUnlock = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 328.9 438.53">
			<path d="m320.9,227.26c-5.33-5.33-11.8-7.99-19.42-7.99H91.36v-91.36c0-20.18,7.14-37.4,21.42-51.68,14.28-14.27,31.5-21.41,51.68-21.41s37.4,7.14,51.67,21.41c14.28,14.28,21.42,31.5,21.42,51.68,0,4.95,1.81,9.23,5.42,12.85,3.62,3.62,7.9,5.43,12.85,5.43h18.28c4.95,0,9.23-1.81,12.85-5.43,3.61-3.62,5.42-7.9,5.42-12.85,0-35.22-12.52-65.33-37.54-90.36C229.78,12.51,199.66,0,164.45,0s-65.33,12.51-90.37,37.54c-25.03,25.03-37.54,55.15-37.54,90.36v91.36h-9.14c-7.61,0-14.08,2.67-19.41,7.99s-7.99,11.8-7.99,19.41v164.45c0,7.62,2.67,14.09,7.99,19.42,5.33,5.33,11.8,7.99,19.41,7.99h274.08c7.62,0,14.09-2.67,19.42-7.99,5.33-5.33,7.99-11.8,7.99-19.42v-164.45c0-7.61-2.66-14.08-7.99-19.41Z" />
		</svg>
	);
};

export default IconUnlock;
